(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["13-custom-section"] && !Shopify.designMode) return;
  try {
    


  /*
  * Swiper Initialization
  * スライダーの初期化と設定
  * - レスポンシブブレイクポイント
  * - スライド表示枚数
  * - ナビゲーションとページネーション
  */
  document.addEventListener('DOMContentLoaded', function() {
    const topics_slider = new Swiper('.topics-slider', {
      slidesPerView: 3,
      spaceBetween: 16,
      centeredSlides: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.custom-nav.swiper-button-next',
        prevEl: '.custom-nav.swiper-button-prev'
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 16,
          centeredSlides: true,
          initialSlide: 0
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 32,
          centeredSlides: false
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fadein-fadeout-view"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var slideshow = document.querySelector('.hero-slideshow');
    var slides = slideshow.querySelectorAll('.hero-slide');
    var currentSlide = 0;
    var autoplay = slideshow.dataset.autoplay === 'true';
    var speed = parseInt(slideshow.dataset.speed) * 1000;
    var mobileImageDisplay = slideshow.dataset.mobileDisplay;
    var interval;

    function showSlide(n) {
      var nextSlideIndex = (n + slides.length) % slides.length;
      var current = slides[currentSlide];
      var next = slides[nextSlideIndex];

      current.classList.remove('active');
      next.classList.add('active');
      currentSlide = nextSlideIndex;
    }

    function nextSlide() {
      showSlide(currentSlide + 1);
    }

    function startAutoplay() {
      interval = setInterval(nextSlide, speed);
    }

    if (autoplay) {
      startAutoplay();
    }

    function lazyLoadImages() {
      var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

      if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.remove("lazy");
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      }
    }

    lazyLoadImages();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-scroll-blog"] && !Shopify.designMode) return;
  try {
    
  class MoScrollBlog extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mo-scroll-blog__track');
      if (!this.track) return;

      this.previous = this.querySelector('button[name="previous"]');
      this.next = this.querySelector('button[name="next"]');
      this.update = this.update.bind(this);

      this.previous?.addEventListener('click', () => this.scrollByPage(-1));
      this.next?.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);

      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    get itemWidth() {
      const item = this.track.querySelector('.mo-scroll-blog__item');
      if (!item) return this.track.clientWidth;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: this.itemWidth * direction, behavior: 'smooth' });
    }

    onScroll() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.update);
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      if (this.previous) this.previous.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('mo-scroll-blog')) {
    customElements.define('mo-scroll-blog', MoScrollBlog);
  }

  } catch(e) { console.error(e); }
})();
})();
